import React, { Suspense } from 'react'; // <-- Suspense importieren
import ReactDOM from 'react-dom/client';
import './index.css'; 
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// === NEU: i18n-Konfiguration importieren ===
// Stellt sicher, dass i18next initialisiert wird, bevor die App lädt
// (Diese Datei haben wir in einem vorherigen Schritt erstellt)
import './i18n-config'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* === HIER IST DER FIX (Error #185) === */}
    {/* Suspense zeigt ein "Lade..." an, bis de.json/en.json geladen sind */}
    <Suspense fallback={<div className="text-center text-xl mt-20">Lade...</div>}>
      <App />
    </Suspense>
    {/* === ENDE FIX === */}
  </React.StrictMode>
);

serviceWorkerRegistration.unregister(); 
reportWebVitals();